import React from 'react';
import { Edit2, Trash2 } from 'lucide-react';
import Button from '../../../components/ui/Button';

const IrrfBracketRow = ({ bracket, onEdit, onDelete }) => {
  const formatCurrency = (value) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    })?.format(value || 0);
  };

  return (
    <tr className="border-b border-border hover:bg-muted/50 transition-colors">
      <td className="py-3 px-4 text-sm text-foreground">{bracket?.ordem}</td>
      <td className="py-3 px-4 text-sm text-foreground">
        {bracket?.limiteSuperior >= 999999999 ? 'Acima' : formatCurrency(bracket?.limiteSuperior)}
      </td>
      <td className="py-3 px-4 text-sm text-foreground">{bracket?.aliquota}%</td>
      <td className="py-3 px-4 text-sm text-foreground">{formatCurrency(bracket?.parceladeduzir)}</td>
      <td className="py-3 px-4 text-right">
        <div className="flex items-center justify-end gap-2">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => onEdit(bracket)}
            className="h-8 w-8"
          >
            <Edit2 className="h-4 w-4" />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            onClick={() => onDelete(bracket?.id)}
            className="h-8 w-8 text-destructive hover:bg-destructive/10"
          >
            <Trash2 className="h-4 w-4" />
          </Button>
        </div>
      </td>
    </tr>
  );
};

export default IrrfBracketRow;